export const UPDATE_DASHBOARD_INTERVAL = 60000;
export const UPDATE_RIGHT_PANEL_INTERVAL = 60000;
export const LASTUPDATED = 'lastUpdated';